import Vue from 'vue'
import router from '@/router'
// axios
import axios from 'axios'
// import { Auth } from 'aws-amplify'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: Vue.prototype.$mainConfig.api.baseURL
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

import { getToken } from '@/auth/utils'

axiosIns.interceptors.request.use(
  async config => {
    // const startTime = performance.now()
    //const value = await Auth.currentAuthenticatedUser().then(userData => userData.signInUserSession.idToken.jwtToken)
    // eslint-disable-next-line no-param-reassign
    const idTokenInfo = getToken('idToken')
    const idToken = idTokenInfo.token || ""

    config.headers = {
      Authorization: idToken,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*'
    }
    // const endTime = performance.now()
    // console.log(`api preprocess: ${endTime - startTime} milliseconds`)

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

const sendApiLog = (response, error = null) => {
  // Loglanmayacak URL'ler
  const excludedUrls = [
    'global/logs/page',
    'global/security/tokencheck',
    'global/consent/check',
    'global/auth',
    'global/logo',
    'onboarding/customer/check_status'
  ]

  if (excludedUrls.includes(response.config.url)) {
    return
  }
  const logData = {
    environment: Vue.prototype.$mainConfig.environment,
    apiUrl: response.config.url,
    apiMethod: response.config.method,
    responseStatus: response.status,
    response: response.status !== 200 ? response.data : null,
    pageName: router.currentRoute.name,
    requestId: response?.headers?.['x-amzn-requestid'] || null,
    payload: {
      postData: (() => {
        try {
          return response.config.data ? JSON.parse(response.config.data) : null
        } catch (e) {
          return response.config.data || null
        }
      })(),
      queryData: response.config.params || null
    }
  }

  axios.post(
    `${Vue.prototype.$mainConfig.api.baseURL}/global/logs/api`,
    logData,
    {
      headers: {
        Authorization: response.config.headers.Authorization,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      }
    }
  )
}

// Response interceptor
axiosIns.interceptors.response.use(
  response => {
    sendApiLog(response)
    return response
  },
  error => {
    if(axios.isCancel(error)){
      Vue.prototype.$logger.methods.apiError({message: "Canceled"})
      if (error.response) {
        sendApiLog({status:"Request Canceled"})
      }
      // Dont resolve or reject on cancel
      if (error.message === 'canceled') {
        return new Promise(() => {}); 
      }
    }else{
      Vue.prototype.$logger.methods.apiError(error.toJSON())
      if (error.response) {
        sendApiLog(error.response, error.toJSON())
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axiosIns

export default axiosIns
